module.exports = "@page {\n  size: landscape;\n  margin: 0; }\n\n.Super {\n  padding: 2rem;\n  background-color: white; }\n"